module.exports = __webpack_public_path__ + "img/039_thumbnail.5d8a5475.jpg";